import { render, staticRenderFns } from "./ClientSupportTickets.vue?vue&type=template&id=5f8181fc&"
import script from "./ClientSupportTickets.vue?vue&type=script&lang=js&"
export * from "./ClientSupportTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports